

import Moment from 'moment';

const formatDateToStandardForm = function (receivedDate, receivedDateFormat, targetDateFormat) {
  var dateToSendBack = "00-00-0000";
  try {
    if (targetDateFormat) {
      dateToSendBack = Moment(receivedDate, receivedDateFormat).format(targetDateFormat);
    } else {
      dateToSendBack = Moment(receivedDate, receivedDateFormat).format("MM/DD/YYYY");
    }
  } catch (err) {
    console.log("err >>", err);
    dateToSendBack = "00-00-0000";
  }
  if(dateToSendBack=="Invalid date"){
    dateToSendBack = "00-00-0000";
  }
  //console.log("receivedDate : dateToSendBack >> " + receivedDate + " : " + dateToSendBack);
  return dateToSendBack;
} 

const formatNumberToStandardFormWithoutComma = function (receivedNumber,props) {
  var enableDecimalRounding = false;
  if(props && props.enableDecimalRounding && props.enableDecimalRounding === "true")
  enableDecimalRounding = true;

  var numberToSendBack = "0.00"
  if(enableDecimalRounding){

    try {
      numberToSendBack = parseFloat(receivedNumber + "");//convertToString
      numberToSendBack = numberToSendBack.toFixed(2);
      if (numberToSendBack === NaN) { numberToSendBack = "0.00" }
    } catch (err) {
      numberToSendBack = "0.00"
    }
  } else {
    try {
      numberToSendBack = parseFloat(receivedNumber); // Convert to a number if it's a string
      
      if (Number.isInteger(numberToSendBack)) {
          numberToSendBack = numberToSendBack.toFixed(2); // For integers, add ".00"
      } else {
        if (numberToSendBack < 0) {
          numberToSendBack = Math.trunc(numberToSendBack * 100) / 100; // For negative non-integers, truncate to 2 decimal places rounding towards zero
      } else {
          numberToSendBack = Math.floor(numberToSendBack * 100) / 100; // For non-negative non-integers, truncate to 2 decimal places rounding down
      }
      
          numberToSendBack = numberToSendBack.toFixed(2);
        }

      if (isNaN(numberToSendBack)) {
        numberToSendBack = "0.00"; 
    }
    
    // console.log("Formatted number: ", numberToSendBack);
  } catch (err) {
      console.error("Error occurred: ", err);
  }
  }
 
  return numberToSendBack;
}

const formatNumberToStandardForm = function (receivedNumber,props) {
  var enableDecimalRounding = false;
  if(props && props.enableDecimalRounding && props.enableDecimalRounding === "true")
  enableDecimalRounding = true;
 
  var numberToSendBack = "0.00";
  
  if(enableDecimalRounding){
    try {
      numberToSendBack = parseFloat(receivedNumber + "");//convertToString
      numberToSendBack = numberToSendBack.toFixed(2);
      if (numberToSendBack === NaN) { numberToSendBack = "0.00" }
    } catch (err) {
      numberToSendBack = "0.00"
    }
  } else {
      try {
        numberToSendBack = parseFloat(receivedNumber); // Convert to a number if it's a string
      
        if (Number.isInteger(numberToSendBack)) {
            numberToSendBack = numberToSendBack.toFixed(2); // For integers, add ".00"
        } else {
          var decimalPlaces = (numberToSendBack.toString().split('.')[1] || []).length;
  
          if (decimalPlaces > 2) {
            // For non-integer numbers with more than two decimal places, round down
            numberToSendBack = (Math.floor(numberToSendBack * 100) / 100).toFixed(2);
          } else {
            // For integers or numbers with two or fewer decimal places, use toFixed directly
            numberToSendBack = numberToSendBack.toFixed(2);
          }
        }
  
        if (isNaN(numberToSendBack)) {
          numberToSendBack = "0.00"; 
      }
      // console.log("Formatted number: ", numberToSendBack);
    } catch (err) {
        console.error("Error occurred: ", err);
    }
   // console.log("Formatted number: ", numberToSendBack);
  } 
  
 
  //finalNumberToSendBack=formatNumberToCommaSeparetedForm(numberToSendBack);
  //finalNumberToSendBack = numberToSendBack;
  return numberToSendBack;
}

const formatNumberToCommaSeparetedForm = function (receivedNumber) {
  var numberToSendBack = "0.00";
  try {
    numberToSendBack = ((receivedNumber + "").replace(/,/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ","));
  } catch (err) {
    numberToSendBack = "0.00";
  }
  return numberToSendBack;
}

const formatNumberToDotSeparetedForm = function (receivedNumber) {
  //receivedNumber =701;
  var numberToSendBack = "0.00";
  try {
    numberToSendBack = ((receivedNumber + "").replace(/,/g, "").replace(/\B(?=(\d{2})+(?!\d))/g, "."));
  } catch (err) {
    numberToSendBack = "0.00";
  }
  if(numberToSendBack.length === 2){
    numberToSendBack =numberToSendBack+".00"
  }
  return numberToSendBack;
}

function formatPhoneNumberToUsFormatNew(phoneNumberString) {
  var numberToReturn = phoneNumberString;
  var phoneNumberStringBackup = phoneNumberString;
  if(phoneNumberString.substring(0, 2) != "1"){
    phoneNumberString = "1"+phoneNumberString;
  }
 
  var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  var match = cleaned.match(/^(\d{1})(\d{3})(\d{3})(\d{4})$/);
  // var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
  if (match) {
    var intlCode = (match[1] ? '1 ' : '1');
    console.log("match>>>",intlCode)
    // return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
    numberToReturn = [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
  }
  numberToReturn = numberToReturn.substring(0,16);
  if(phoneNumberStringBackup.length > numberToReturn.length){
   // Toast.showToast("Entered number is too long");
  }
  return numberToReturn;
}

function formatPhoneNumberToUsFormat(phoneNumberString) {
  console.log("received Number" + phoneNumberString);
  var numberToReturn = phoneNumberString;
  var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  var match = cleaned.match(/^(\d{1})(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    numberToReturn = [match[1],' (', match[2], ') ', match[3], '-', match[4]].join('');
  }
  numberToReturn = numberToReturn.substring(0,16);
  console.log("return Number" + numberToReturn);
  return numberToReturn;
}


function formatSsnNumber(receivedSsn) {
  var numberToReturn = receivedSsn;
  var cleaned = ('' +receivedSsn).replace(/\D/g, '');
  var match = cleaned.match(/^(\d{3})(\d{2})(\d{4})$/);
  if (match) {
    numberToReturn = ['×××', '-', '××', '-', match[3]].join('');
  }

  // if((/^[0-9]+$/).test(receivedSsn) != true){
  //   numberToReturn = receivedSsn;
  //   Toast.showToast("number cant be too long");
  // }
 
  return numberToReturn;
}

function convertZipToStandardForm(receivedZip) {
  var finalZipToReturn = "" + receivedZip;
  finalZipToReturn = finalZipToReturn.substring(0, 5) + "-" + finalZipToReturn.substring(5, finalZipToReturn.length);
  return finalZipToReturn;
}

function stringToStandardForm(receivedString, receivedType) {
  var finalStringToReturn1 = "";
  var finalStringToReturn2 = "";
  try {
    var splittedArray1 = receivedString.split(/[,]+/);

    for (var i = 0; i < splittedArray1.length; i++) {
      var currentWord = splittedArray1[i];
      if (receivedType == "upper") {
        finalStringToReturn1 += currentWord.toUpperCase();
      } else if (receivedType == "lower") {
        finalStringToReturn1 += currentWord.toLowerCase();
      } else {
        finalStringToReturn1 += currentWord[0].toUpperCase() + currentWord.slice(1).toLowerCase();
      }
      if (i < splittedArray1.length - 1) { finalStringToReturn1 += ", " }
    }


    var splittedArray2 = finalStringToReturn1.split(/[ ]+/);

    for (var i = 0; i < splittedArray2.length; i++) {
      var currentWord2 = splittedArray2[i];
      if (receivedType == "upper") {
        finalStringToReturn2 += currentWord2.toUpperCase();
      } else if (receivedType == "lower") {
        finalStringToReturn2 += currentWord2.toLowerCase();
      } else {
        finalStringToReturn2 += currentWord2[0].toUpperCase() + currentWord2.slice(1);
      }
      if (i < splittedArray2.length - 1) { finalStringToReturn2 += " " }
    }
  } catch (err) {
    finalStringToReturn2 = "";
  }
  return finalStringToReturn2;
}

export default {
  formatDateToStandardForm, formatPhoneNumberToUsFormatNew, formatNumberToDotSeparetedForm,formatNumberToStandardFormWithoutComma,formatNumberToStandardForm, formatNumberToCommaSeparetedForm, formatPhoneNumberToUsFormat, formatSsnNumber, convertZipToStandardForm, stringToStandardForm
}
